module.exports = __webpack_public_path__ + "img/copy-link.cfe8839e.svg";